import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@fluentui/react-components';

const SpinnerShimInternal = React.forwardRef((props, _ref) => {
  const { labelPosition, ...rest } = props;

  const labelPositionMapping = {
    bottom: 'below',
    top: 'above',
    left: 'before',
    right: 'after',
  };

  return (
    <Spinner
      {...rest}
      ref={_ref}
      labelPosition={labelPositionMapping[labelPosition]}
    />
  );
});

SpinnerShimInternal.defaultProps = {
  labelPosition: 'bottom',
};

SpinnerShimInternal.propTypes = {
  labelPosition: PropTypes.oneOf(['bottom', 'top', 'left', 'right']),
};

export const SpinnerShim = SpinnerShimInternal;
